import { render } from "./TlbsOfferRenewalPifComponent.vue?vue&type=template&id=090def8f&ts=true"
import script from "./TlbsOfferRenewalPifComponent.vue?vue&type=script&lang=ts"
export * from "./TlbsOfferRenewalPifComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__